import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'tog-simple-scrollable-table',
  templateUrl: './simple-scrollable-table.component.html',
  styleUrls: ['./simple-scrollable-table.component.scss']
})
export class SimpleScrollableTableComponent implements OnInit {
  columnOne: string[] = [];
  columnTwo: string[] = [];
  twoColumnMode: boolean = false;
  @Input() switchToTwoColumnModeAt: number = 8;

  constructor() { }

  ngOnInit() { }

  @Input() set elements(elements: string[]) {
    this.columnOne = elements.slice();
    this.twoColumnMode = elements.length > this.switchToTwoColumnModeAt;
    if (this.twoColumnMode) this.adjustForTwoColumns();
  }

  adjustForTwoColumns() {
    let columnOneAmount = Math.ceil(this.columnOne.length / 2);
    this.columnTwo = this.columnOne;
    this.columnOne = this.columnTwo.splice(0, columnOneAmount);
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/components/simple-scrollable-table/simple-scrollable-table.component.ts